import React from "react";
import classes from "./styles.module.scss";
import PageLogo from "../../assets/images/image 967.png";
import PropTypes from "prop-types";

const Header = (props) => {
    return(
        <div className={classes.header_container}>
            <div className={classes.header_content}>
                <div className={classes.left_section}>
                    <img src={PageLogo} alt="logo" />
                    <div className={classes.brand_text}>
                        <p className={classes.big}>Students Registration</p>
                        <p className={classes.small}>2025-2026</p>
                    </div>
                </div>
                <div className={classes.right_section}>
                    <p className={classes.big}>{props.header_text}</p>
                    <p className={classes.small}>{props.sub_text}</p>
                </div>
            </div>
        </div>
    )
}

Header.propTypes = {
    header_text: PropTypes.string.isRequired,
    sub_text: PropTypes.string.isRequired
};

export default Header;